import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { EditUserFormType } from '../components/UserManagement/AddEditUserModal/AddEditUserModal'

// TODO: refactor types in request and component that uses this hook if you use it
const updateUser = async (payload: EditUserFormType) => {
  const accountId = useUserStore.getState().accountId
  return await request({
    method: 'PUT',
    url: `accounts/${accountId}/users`,
    data: { ...payload, role: payload.role },
  })
}

export const useEditUsers = () => {
  const queryClient = useQueryClient()
  const { mutate, isLoading, isError, error } = useMutation(updateUser, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['users'])
    },
  })

  return { mutate, isLoading, isError, error }
}
